<template>
  <div>正在跳转登录中...</div>
</template>

<script>
import { Message } from 'element-ui';
import { isEmpty } from 'lodash';
import { loginBySSO } from '@/common/auth/';
import * as $cache from '@/common/cache';
import Request from '@/core/QuRequest';

const req = new Request();

// 登录 CRM
// 使用 SSO 颁发的 code 进行 CRM 登录
// 登录成功后会颁发一个 CRM 的 token
// 后续请求都是用 CRM 的 token
// 如果 code 失效则重新使用 SSO 登录
async function login(code) {
  try {
    const params = { token: code };
    const res = await req.send(req.Apis.sales.user.syncAuth, params);
    if (res.code === 200) {
      const { token } = res.data;
      if (token) {
        $cache.localSet($cache.AUTH, res.data);
      } else {
        Message.error('获取 token 失败, 请重新登录');
        loginBySSO();
      }
    }
  } catch (err) {
    Message.error(err.message);
    if (err.code === 102) {
      // code 失效，重新跳转 SSO 登录
      console.log('验证 code 失效，请重新登录');
      // loginBySSO();
    }
  }
}

// 获取用户信息
async function getUserInfo() {
  try {
    const res = await req.send(req.Apis.sales.user.userInfo);
    if (res.code === 200) {
      return res.data;
    }
    return null;
  } catch (err) {
    Message.error(err.message);
  }
}

export default {
  async beforeRouteEnter(to, from, next) {
    console.log('登录页鉴权');
    const { query } = to;
    if (query.code) {
      console.log('SSO 登录成功');
      await login(query.code);
      console.log('CRM 登录成功');
      next((vm) => {
        vm.$router.push('/');
      });
    } else {
      console.log('获取用户信息');
      const res = await getUserInfo();
      if (res && !isEmpty(res)) {
        console.log('已登录，跳转至首页');
        next((vm) => {
          vm.$router.push('/');
        });
        return;
      } else {
        console.log('跳转SSO登录');
        loginBySSO();
      }
    }
  },
};
</script>
